export enum EnumPermissao {
    RealizarBuscaAvancada = 1,
    FazerSegmentacao = 2,
    GerarListaContatos = 3,
    VisualizarContatos = 4,
    ExportarLista = 5,
    ConsultarMargem = 6,
    CriarNovosUsuarios = 7,
    FazerRecarga = 8,
    VisualizarSegmentacoesOutrosUsuarios = 9,
    VisualizarRelatorios = 10
  }